import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { mingaSettingTypes } from 'libs/util';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { MingaSettingsService } from '@app/src/app/store/Minga/services';

import { ToolsRoutes } from '../tools.types';

@Injectable({
  providedIn: 'root',
})
export class PointsDefaultRedirectGuard implements CanActivate {
  constructor(private _router: Router, private _settingsService: MingaSettingsService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isLeaderboardEnabled$ = this._settingsService.getSettingValueObs(
      mingaSettingTypes.FEATURE_TRACKING_PUBLIC_LEADERBOARD,
    );

    return isLeaderboardEnabled$.pipe(
      take(1),
      map(isLeaderboardEnabled => {
        const defaultRoute = isLeaderboardEnabled ? ToolsRoutes.LEADERBOARD : ToolsRoutes.YOUR_POINTS;
        const route = `/${ToolsRoutes.ROOT}/${ToolsRoutes.POINTS}/${defaultRoute}`;
        this._router.navigate([route], { replaceUrl: true });
        return false; // Prevent the original route from activating
      }),
    );
  }
}
